import React, { useState } from 'react';
import donationAPI, { APIErrorHandler } from '../config/api-config';

const StripeCheckoutButton = ({
  selectedAmount,
  isMonthly,
  customerData,
  onPaymentAttempt,
  disabled = false,
  lang = 'fr' // ← Défaut français
}) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  // 🌍 TRADUCTIONS COMPLÈTES FR/EN/ES
  const translations = {
    fr: {
      donate: 'Faire un don de',
      perMonth: '/mois',
      redirecting: 'Redirection vers Stripe...',
      errorFillFields: 'Veuillez remplir tous les champs obligatoires avant de continuer.',
      securePayment: 'Vous serez redirigé vers la page de paiement sécurisée de Stripe.',
      errorGeneric: 'Une erreur est survenue. Veuillez réessayer.'
    },
    en: {
      donate: 'Donate',
      perMonth: '/month',
      redirecting: 'Redirecting to Stripe...',
      errorFillFields: 'Please fill in all required fields before proceeding.',
      securePayment: "You'll be redirected to Stripe's secure payment page.",
      errorGeneric: 'An error occurred. Please try again.'
    },
    es: {
      donate: 'Donar',
      perMonth: '/mes',
      redirecting: 'Redirigiendo a Stripe...',
      errorFillFields: 'Por favor, complete todos los campos obligatorios antes de continuar.',
      securePayment: 'Será redirigido a la página de pago segura de Stripe.',
      errorGeneric: 'Ocurrió un error. Por favor, inténtelo de nuevo.'
    }
  };

  const t = translations[lang] || translations.fr;

  const handleCheckoutClick = async () => {
    if (onPaymentAttempt && !onPaymentAttempt()) {
      setError(t.errorFillFields);
      return;
    }

    setLoading(true);
    setError(null);

    try {
      console.log('🛒 Starting Stripe Checkout...', { lang, currency: 'EUR' });

      // ✅ PASSER LA LANGUE À L'API
      const result = await donationAPI.createCheckoutSession(
        selectedAmount,
        {
          ...customerData,
          language: lang // ← Ajouter la langue dans customerData
        },
        isMonthly
      );

      console.log('✅ Checkout session created:', result);

      // 🔧 CORRECTION : Accepter "checkout_url" OU "url"
      const checkoutUrl = result.checkout_url || result.url;

      if (!checkoutUrl) {
        console.error('❌ Response structure:', result);
        throw new Error('No checkout URL received from server');
      }

      console.log('🚀 Redirecting to Stripe:', checkoutUrl);
      window.location.href = checkoutUrl;

    } catch (error) {
      console.error('❌ Checkout failed:', error);
      
      const userFriendlyMessage = APIErrorHandler.getErrorMessage(error, lang) || t.errorGeneric;
      setError(userFriendlyMessage);
      
      APIErrorHandler.logError(error, {
        amount: selectedAmount,
        isMonthly: isMonthly,
        customerEmail: customerData.email,
        language: lang
      });
      
      setLoading(false);
    }
  };

  return (
    <div className="checkout-button-container">
      {error && (
        <div className="payment-error">
          <span className="error-icon">⚠️</span>
          {error}
        </div>
      )}
      
      <button
        onClick={handleCheckoutClick}
        disabled={disabled || loading || !selectedAmount || selectedAmount < 1}
        className="btn-primary checkout-button"
      >
        {loading ? (
          <>
            <span className="spinner"></span>
            {t.redirecting}
          </>
        ) : (
          <>
            {/* ✅ AFFICHAGE AVEC EUROS */}
            {t.donate} {selectedAmount.toFixed(2)} € {isMonthly ? t.perMonth : ''}
          </>
        )}
      </button>

      <div className="checkout-info">
        <p>
          <small>
            {t.securePayment}
          </small>
        </p>
      </div>
    </div>
  );
};

export default StripeCheckoutButton;